export default {
    intro: `글감을 보고, 나만의 글을 써보세요.<br />
            친구들의 글도 보고, 맘에 드는 글에 투표도 해보세요.`,
    buttons: {
        cancel: '취소하기',
        submit: '제출하기',
    },
    options: {
        timer: {
            title: '타이머 설정',
            inputTime: '작성 시간',
            voteTime: '투표 시간',
        },
        example: {
            title: '예시 답안 노출',
            description: '학생들 화면에 예시 답안이 노출됩니다.',
        },
        votesPerStudent: {
            title: '학생당 투표 수 설정',
        },
    },
    noTitleCard: '제목이 없는 카드 입니다',
    noContentCard: '내용이 없는 카드 입니다',
    exampleAnswer: '예시 답안',
    tabs: {
        check: '1.글감 확인',
        write: '2.카드 작성',
        vote: '3.투표 진행',
        result: '4.투표 결과',
    },
    tabStudent: {
        write: '글감을 보고 내 생각을 글로 써보세요.',
        previousVote: '투표 전 친구들의 글을 읽어 보세요.',
        vote: '마음에 드는 글에 투표해 주세요.',
        result: '친구들이 가장 좋아한 글을 확인해 보세요!',
    },
    card: {
        title: '제목을 적지 않았어요 😶',
        content: '아무런 내용도 적지 않았어요 😵',
    },
    cardWritingArea: {
        titlePlaceholder: '제목을 입력해 주세요. (30자 내외)',
        contentPlaceholder: '내용을 입력해 주세요. ',
    },
    loading: {
        voteStart: '투표 시작',
        voteResult: '투표 집계중',
        readNext: '다음 글감 준비중',
    },
    vote: {
        selfVote: '자기자신은 투표하시지 않아요',
        voteLimit: '투표 수를 모두 사용했어요.',
    },
    student: {
        inPlay: {
            readyText: `글감을 보면서<br />어떤 글을 쓸지 생각해봐요.`,
            topic: '글감',
        },
        toast: {
            contentLengthWarning: '내용은 2,000자 이내로 입력해주세요.',
            titleLengthWarning: '제목은 30자 내로 적어주세요.',
            inputEndWarning: '15초 남았어요. 곧 작성 시간이 종료됩니다.',
            voteEndWarning: '15초 남았어요. 곧 투표가 종료됩니다.',
        },
    },
    teacher: {
        setting: {
            titlePlaceholder: '글감 제목을 입력해주세요. (최대 200자)',
            textPlaceholder: '글감 설명을 입력해주세요. (최대 1,000자)',
            inputErrorMessage: '입력해주세요',
            delete: '삭제',
            register: '등록',
            cancel: '취소',
            addQuestion: '+ 글감 추가',
        },
        inPlay: {
            readyTextInput: `글감을 설명한 후 <br />
                                    ‘작성 시작’을 눌러주세요`,
            readyTextSubmit: `학생들이 제출하면 <br />
                                    여기 표시됩니다.`,
        },
        modal: {
            title: '와글와글 💬',
            startConfirm: {
                message: '글감 추가를 위해 작성 중인 내용이 있습니다.',
                subMessage: '지금 활동을 시작하면 작성한 내용이 모두 삭제되고, 문항으로 추가되지 않습니다.',
                optionalMessage: '그래도 활동을 시작할까요?',
                confirmText: '활동 시작',
                cancelText: '계속 작성',
            },
            voteStart: {
                message: '아직 작성 중인 학생이 있어요.',
                subMessage: '카드를 이대로 제출하고 투표를 시작할까요?',
                confirmText: '투표 시작하기',
            },
            voteEnd: {
                message: '투표 시간이 종료되었어요.',
                subMessage: '결과를 확인할까요?',
                confirmText: '결과 확인하기',
            },
            questionDelete: {
                message: '글감을 삭제할까요?',
                subMessage: '삭제된 글감은 복구할 수 없습니다.',
                confirmText: '삭제하기',
            },
        },
        button: {
            step: {
                beforeStart: '작성 시작',
                writingEnd: '작성 종료',
                voteEnd: '투표 종료',
                nextTopic: '다음 글감',
                activityStart: '활동 시작',
            },
        },
    },
};
